var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('noscript',{inlineTemplate:{render:function(){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"courses-intro__subtitle"},[_vm._v(_vm._s(_vm.seo.subtitle))])},staticRenderFns:[]}})}
var staticRenderFns = []

export { render, staticRenderFns }